import type { CanvasSpecifier } from "../../api-types";
import type { LoggerInterface } from "../../logger-types";
import {
	type RoomClient,
	type StorageClientRegistry,
	getCacheKey,
} from "../../page-local-storage/client/index";
import { PageLocalStorageClient } from "../../page-local-storage/client/pageLocalStorageClient";

export const DEFAULT_PING_INTERVAL_MS = 45_000;

export interface ConfigurationFromSpecifierResult {
	socket: RoomClient;
	fetch: (init?: RequestInit | undefined) => Promise<Response>;
}

export class PageStorageFactory {
	// The bridge registry is passed down through a constructor in order to reuse it for creating new page storage clients.
	private storageClientRegistry: StorageClientRegistry;

	private logger: LoggerInterface;
	// private configFromCanvasSpecifier: (
	// 	canvasSpecifier: CanvasSpecifier
	// ) => ConfigurationFromSpecifierResult;

	constructor(opts: {
		registry: StorageClientRegistry;
		logger: LoggerInterface;
		configFromCanvasSpecifier: (
			canvasSpecifier: CanvasSpecifier
		) => ConfigurationFromSpecifierResult;

		onOpen: () => void;
		onClose: (event: CloseEvent) => void;
		onError: (event: ErrorEvent) => void;
		connectStatus: (status: string) => void;
		onReloadRequired: () => void;
	}) {
		this.storageClientRegistry = opts.registry;
		this.logger = opts.logger;
	}

	create(
		canvasId: string,
		pageId: string
	): { client: PageLocalStorageClient; onDispose: () => void } {
		const cacheKey = getCacheKey({ id: canvasId, pageId });
		const canvasSpecifier = {
			id: canvasId,
			pageId,
		};

		const registeredClient = this.storageClientRegistry.get(cacheKey);
		if (registeredClient) {
			return {
				client: registeredClient.client,
				onDispose: registeredClient.dispose,
			};
		}

		return {
			client: new PageLocalStorageClient({
				canvasSpecifier,
				logger: this.logger,
				pingIntervalMs: DEFAULT_PING_INTERVAL_MS,
				fetch: () => {
					throw new Error("fetch not implemented");
				},
			}),
			onDispose: () => {},
		};
	}
}
